module.exports = function() {
  return new Worker("/" + "assets/unzip_imgs.worker.4fbc4aa82fdfb5b3854e.js");
};